<ng-container *transloco="let t; read: 'resource'">
<div class="p-5">
  <div class="flex justify-between items-center">
    <drdp-title [title]="t('uploadTemplates.title')"></drdp-title>
  </div>

  <div class="flex flex-wrap gap-4 py-3">
    <drdp-container color="whiteDash" class="h-62 w-48">
      <button (click)="downloadTemplate(uploadTypes.user)" class="w-full pb-4">
        <i class="text-drdpblue-300 text-[60px] uil uil-file-download block pb-[22px]"></i>
        <p class="text-[15px]" [title]="t('uploadTemplates.usersTooltip')">{{ t('uploadTemplates.users') }}</p>
        <p class="text-drdpblue-300 text-[15px]">{{ t('common.download') }}</p>
      </button>
    </drdp-container>

    <drdp-container color="whiteDash" class="h-62 w-48">
      <button (click)="downloadTemplate(uploadTypes.class)" class="w-full pb-4">
        <i class="text-drdpblue-300 text-[60px] uil uil-file-download block pb-[22px]"></i>
        <p class="text-[15px]" [title]="t('uploadTemplates.classTooltip')">{{ t('uploadTemplates.class') }}</p>
        <p class="text-drdpblue-300 text-[15px]">{{ t('common.download') }}</p>
      </button>
    </drdp-container>

    @if (enforceStateConfig === false || overrideRatings) {
      <drdp-container color="whiteDash" class="h-62 w-48">
        <button (click)="downloadTemplate(uploadTypes.student)" class="w-full pb-4">
          <i class="text-drdpblue-300 text-[60px] uil uil-file-download"></i>
          <p class="text-[15px]" [title]="t('uploadTemplates.childTooltip')">{{ t('uploadTemplates.child') }}</p>
          <p class="text-[15px]" [title]="t('uploadTemplates.drdp2015')">{{ t('uploadTemplates.drdp2015') }}</p>
          <p class="text-drdpblue-300 text-[15px]">{{ t('common.download') }}</p>
        </button>
      </drdp-container>

      @if (stateId == states.california) {
      <drdp-container color="whiteDash" class="h-62 w-48">
        <button (click)="downloadTemplate(uploadTypes.student2025)" class="w-full pb-4">
          <i class="text-drdpblue-300 text-[60px] uil uil-file-download"></i>
          <p class="text-[15px]" [title]="t('uploadTemplates.child2025Tooltip')">{{ t('uploadTemplates.child') }}</p>
          <p class="text-[15px]" [title]="t('uploadTemplates.drdp2025EarlyAdopter')">{{ t('uploadTemplates.drdp2025EarlyAdopter') }}</p>
          <p class="text-drdpblue-300 text-[15px]">{{ t('common.download') }}</p>
        </button>
      </drdp-container>
      }
    }

    @if (enforceStateConfig) {
      <drdp-container color="whiteDash" class="h-62 w-48">
        <button (click)="downloadTemplate(uploadTypes.student2025Final)" class="w-full pb-4">
          <i class="text-drdpblue-300 text-[60px] uil uil-file-download"></i>
          <p class="text-[15px]" [title]="t('uploadTemplates.child2025Tooltip')">{{ t('uploadTemplates.child') }}</p>
          <p class="text-[15px]" [title]="t('uploadTemplates.drdp2025')">{{ t('uploadTemplates.drdp2025') }}</p>
          <p class="text-drdpblue-300 text-[15px]">{{ t('common.download') }}</p>
        </button>
      </drdp-container>
    }
  </div>
</div>
</ng-container>
